import React from 'react'
import { connect } from 'react-redux'
import { Dropdown, Avatar } from 'antd'
import type { MenuProps } from 'antd'
import styles from './style.module.scss'
import { ReducerType } from "../../../../redux/reducer.type";
import { MenuUserPropsType, MenuUserStateType } from "./menuUser.type";
import actions from "../../../../redux/user/actions";
import compose from "../../../../utils/zloz";
import { withTranslation } from 'react-i18next';
import {faSignOutAlt, faUser, faCheck} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ROUTE_PROFILE_EDIT } from "../../../../config/routes";
import { Link } from "react-router-dom";
import {WorkspaceType} from "../../../../redux/user/user.type";
import {languages} from "../../../../config/config";
import { Select } from 'antd';
import i18n from '../../../../i18n';
import UserOutlined from "@ant-design/icons/UserOutlined";

const { Option } = Select;

class ProfileMenu extends React.Component<MenuUserPropsType, MenuUserStateType> {
    state = {
        visible: false,
    };
    handleVisibleChange = (flag: boolean) => {
        this.setState({ visible: flag });
    };
    logout = () => {
        const { dispatch } = this.props;
        dispatch({
            type: actions.LOGOUT,
        })
    };

    changeWorkspace = (el: WorkspaceType) => {
        const { dispatch } = this.props;
        dispatch({
            type: actions.CHANGE_ACTIVE_WORKSPACE,
            payload: el
        });
    };

    changeLanguage = (value: string) => {
        localStorage.setItem('language', value);
        i18n.changeLanguage(value);
    };

  render() {
    const { user, t } = this.props;
    /*
     * <Menu> W <Dropdown> ZASTAPIONE LISTA `items`.
     *
     * W antd 5 `overlay` na <Dropdown> i <Menu.Item> jako dziecko sa
     * przestarzale - kazde wypisuje ostrzezenie. To ta sama lista,
     * tylko opisana obiektem; tresc pozycji przepisana bez zmian.
     *
     * `key` przy separatorach i pozycjach stalych dopisane jawnie:
     * w antd 3 rc-menu nadawalo je samo z kolejnosci dzieci.
     */
    const menu: MenuProps = {
        selectable: false,
        style: {minWidth: 250},
        items: [
            {
                key: "uzytkownik",
                label: <strong>{t('user_menu_prefix_user')}, {user.first_name}</strong>,
            },
            { type: "divider", key: "separator-1" },
            ...user.workspaces.map((el) => (
                user.activeWorkspace && el.uuid === user.activeWorkspace.uuid ? {
                    key: el.uuid,
                    label: (
                        <>
                            <FontAwesomeIcon icon={faCheck} className={styles.menuIcon} />
                            <strong>{user.activeWorkspace.name}</strong>
                        </>
                    ),
                } : {
                    key: el.uuid,
                    label: (
                        <span style={{marginLeft: 18}}>
                            {el.name}
                        </span>
                    ),
                    onClick: () => this.changeWorkspace(el),
                }
            )),
            { type: "divider", key: "separator-2" },
            {
                key: "profil",
                label: (
                    <Link to={ROUTE_PROFILE_EDIT} >
                        <FontAwesomeIcon icon={faUser} className={styles.menuIcon} />
                        {t('menu_user_edit_profile')}
                    </Link>
                ),
            },
            {
                key: "jezyk",
                label: (
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <span style={{marginLeft: 16}}>{t('menu_user_change_language')}</span>
                        <Select defaultValue={i18n.language} size="small" onChange={this.changeLanguage}>
                            {languages.map(el => (
                                <Option key={el.i18n} value={el.i18n}>{el.name}</Option>
                            ))}
                        </Select>
                    </div>
                ),
            },
            { type: "divider", key: "separator-3" },
            {
                key: "wyloguj",
                label: (
                    <button type="button" className="linkButton">
                        <FontAwesomeIcon icon={faSignOutAlt} className={styles.menuIcon} />
                        {t('user_menu_logout')}
                    </button>
                ),
                onClick: this.logout,
            },
        ],
    };
    return (
        <>
            <Dropdown
                menu={menu}
                trigger={['click']}
                onOpenChange={this.handleVisibleChange}
                open={this.state.visible}
            >
                <div className={styles.dropdown}>
                    <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
                </div>
            </Dropdown>
        </>
    )
  }
}

const mapStateToProps = (state: ReducerType) => ({ user: state.user });

export default compose<MenuUserPropsType, {}>(
    connect(mapStateToProps),
    withTranslation('template')
)(ProfileMenu)
